import React, { useRef, useEffect } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/actions";

import "./TicketsSideBar.css";
import TicketsSideBarTabs from "./TicketsSideBarTabs";
import TicketSideBarItem from "./TicketSideBarItem";
import TicketSideBarItemError from "./TicketSideBarItemError";
import EmptySideBar from "../EmptySideBar";

import useWindowDimensions from "../../../WindowDimensions-hook/useWindowDimensions";

function findStatus(ticketStatusArray, ticketId, categoryTickets) {
  if (ticketStatusArray === null) return null;
  else {
    const isFound = ticketStatusArray.find(
      (item) =>
        item.ticketId === parseInt(ticketId) &&
        item.ticketCategory === categoryTickets
    );

    if (isFound === undefined) return undefined;
    else if (isFound.ticketStatus === true) return true;
    else return false;
  }
}

const TicketsSideBar = (props) => {

  const ref = useRef(null)
  const itemRef = useRef(null)

  useEffect(() => {
    /* console.log(ref.current.scrollTop, "ref")
    console.log(itemRef.current.offsetTop, "itemRef")
    console.log(itemRef, "itemRef") */

    let offsetParametr;
    if (props.categoryTickets === "ticketsAB" || props.categoryTickets === "themeAB") { offsetParametr = 225 }
    else {
      offsetParametr = 160
    }
    if (ref && itemRef) {
      ref.current.scrollTo({
        top: itemRef.current && itemRef.current.offsetTop - offsetParametr,
        behavior: "smooth"
      });
    }
  }, [ref, itemRef, props.paramsTicketId, props.isErrorItemExist, props.categoryTickets]);

  const { width, height } = useWindowDimensions();

  let offset;
  if (props.categoryTickets === "ticketsAB" || props.categoryTickets === "themeAB") { offset = 130 }
  else { offset = 50 }

  return (
    <div className="side-bar-tickets">
      <TicketsSideBarTabs
        categoryTickets={props.categoryTickets}
        firstTicketErrorsTicketsAB={props.firstTicketErrorsTicketsAB}
        firstTicketErrorsTicketsCD={props.firstTicketErrorsTicketsCD}
      />

      <div ref={ref} className="side-bar-scroll" style={width <= 568 ? { maxHeight: height - offset } : {}}>
        {props.ticketsArray !== undefined &&
          (props.categoryTickets === "ticketsAB" ||
            props.categoryTickets === "ticketsCD" || props.categoryTickets === "themeAB") ? (
          props.ticketsArray.map((ticket) => (
            <div
              key={ticket.ticketId}
              ref={props.paramsTicketId === ticket.ticketId ? itemRef : null}
            >
              <TicketSideBarItem
                closeSideBarMobile={props.closeSideBarMobile}
                categoryTickets={props.categoryTickets}

                header={ticket.header}
                ticketId={ticket.ticketId}
                isActiveTicketItem={props.paramsTicketId === ticket.ticketId}
                status={findStatus(
                  props.ticketStatusArray,
                  ticket.ticketId,
                  props.categoryTickets
                )}
              />
            </div>)
          )
        ) : props.categoryTickets === "themeCD" ?
          <EmptySideBar text="Вопросы из категории CD нельзя разбить на темы" />
          : props.ticketsArray !== undefined &&
            (props.categoryTickets === "errorsAB" ||
              props.categoryTickets === "errorsCD") &&
            props.isErrorItemExist ? (
            props.ticketsArray.map((ticket) => (
              <div
                key={ticket.ticketId}
                ref={props.paramsTicketId === ticket.ticketId ? itemRef : null}
              >
                <TicketSideBarItemError
                  closeSideBarMobile={props.closeSideBarMobile}
                  key={ticket.ticketId}
                  ticketId={ticket.ticketId}
                  ticketErrors={ticket.tasks}
                  categoryTickets={props.categoryTickets}
                />
              </div>
            ))
          ) : (props.ticketsArray.length === 0 && (props.categoryTickets === "errorsAB" || props.categoryTickets === "errorsCD")) ? (
            <EmptySideBar text="Здесь будут появляться билеты, в которых вы допустили ошибки" />
          ) : (
            <></>
          )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    numbersStateArray: state.ticketsReducer.numbersStateArray,
    paramsTicketId: state.router.location.pathname.split("/")[2],
    ticketStatusArray: state.ticketsReducer.ticketStatusArray,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    resetNumbersStateArray: () =>
      dispatch({
        type: actionTypes.RESET_NUMBERS_STATE_ARRAY,
      }),
    setTicketsArray: (ticketsArray) =>
      dispatch({
        type: actionTypes.SET_TICKETS_ARRAY,
        ticketsArray: ticketsArray,
      }),
    setLoadedBilet: (loadedBilet) =>
      dispatch({
        type: actionTypes.SET_LOADED_BILET,
        loadedBilet: loadedBilet,
      }),
    setClickedAnswerId: (id) =>
      dispatch({
        type: actionTypes.SET_CLICKED_ANSWER_ID,
        clickedAnswerId: id,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketsSideBar);

/* // кнопка AB
props.categoryTickets === "ticketsCD" || props.categoryTickets === "ticketsAB"
? "/ticketsAB/1/1"
: props.lsErrorsTicketsAB[0] !== undefined
? `/errorsAB/${props.lsErrorsTicketsAB[0].ticketId}/${props.lsErrorsTicketsAB[0].ticketErrors[0]}`
: "/errorsAB/1/1";

// кнопка CD
props.categoryTickets === "ticketsCD" || props.categoryTickets === "ticketsAB"
? "/ticketsCD/1/1"
: props.lsErrorsTicketsCD[0] !== undefined
? `/errorsCD/${props.lsErrorsTicketsCD[0].ticketId}/${props.lsErrorsTicketsCD[0].ticketErrors[0]}`
: "/errorsCD/1/1"; */
